import { ISpaceArticleSection } from 'shared/types/SpaceArticleSection';

export const getThemeBackgroundColorFromSpaceArticle = (space: ISpaceArticleSection) => {
  return space.articles?.[0]?.sections?.[0]?.bgColor || null;
};
